<template>

    <section class="dd-m-carousel dd-m-carousel--lites dd-m-carousel--custom-dots" :style="{backgroundColor: bgColor || 'white'}">
        <loading type="banner" v-if="isLoading"></loading>

        <div class="dd-l-container__wrapper dd-l-container__wrapper--grid-tb" v-if="results.length">
            <div class="dd-m-carousel--lites__content flex_content" :class="{reverse}">

                <div class="content_left">    
                    <h2 class="dd-m-carousel--lites__title">{{title}}</h2>
                    <p class="dd-m-carousel--lites__description">{{description}}</p>
                </div>

                <div class="dd-m-carousel__variable-slider custom_slider">
                    <Slick ref="slick" :options="slickOptions">
                        <card-custom 
                            v-for="(item, index) in results" 
                            :hide-card-title="hideCardTitle" 
                            :item="item"
                            :key="index"></card-custom>
                    </Slick>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
    import axios from 'axios';
    import SlickOptions from '../../providers/slick';
    import Slick from "vue-slick";
    import Loading from "../loading";
    //import CardLite from "../cards/card-lite";
    import CardCustom from "../cards/card-custom";

    const slickOptions = new SlickOptions();

    export default {
        name: 'banner-list-lites',
        components: {CardCustom, Loading, Slick},
        props: ['hideCardTitle', 'perPage', 'title', 'description', 'reverse', 'bannerId', 'bgColor'],
        data: () => {
            return {
                results: [],
                slickOptions: slickOptions.getCustomDefaultLites(true),
                isLoading: false
            }
        },
        mounted() {
            this.isLoading = true;
            var id = this.bannerId || 5;
            axios.get(`/api/banner/${id}?language=${language}&perPage=${this.perPage ? this.perPage : ''}`)
                .then((res) => {
                    this.results = res.data.data;
                    this.isLoading = false;
                })
                .catch(() => this.isLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-list-lites.vue